export async function getCustomComponents(components) {
  let customComponents = [];
  let customComponentsKeys = [];
  for (const filePath of components.keys()) {
    const customComponent = await components(filePath);
    //save component in arr
    customComponents.push(customComponent.default);
    //save component name in arr
    customComponentsKeys.push(filePath.replace('./', '').replace('.vue', ''));
  }

  //create obj from components with component name as key
  const customComponentConfig = customComponentsKeys.reduce((prev, key, i) => {
    prev[key] = customComponents[i];
    return prev;
  }, {});

  return customComponentConfig;
}

export function loadComponents() {
  const context = require.context('../views', true, /\.view\.vue$/);
  return context
    .keys()
    .map(context) // import module
    .map(m => m.default); // get `default` export from each resolved module
}

export function getComponent(components, componentName) {
  const filteredComponent = components.filter(route => {
    return componentName === getComponentName(route.__file);
  });

  return filteredComponent[0];
}

function getComponentName(path) {
  let firstHalfPath = path.split('.view')[0];
  let pathSections = firstHalfPath.split('/');
  return pathSections[pathSections.length - 1];
}

export function generateNestedRoutes(nestedRoutes, flattenedSubRoutes) {
  nestedRoutes.forEach(item => {
    flattenedSubRoutes.push({ name: item.name, component: item.component, path: item.path, roles: item.roles });
    if (item.subRoutes) {
      let moreRoutes = generateNestedRoutes(item.subRoutes, flattenedSubRoutes);
      flattenedSubRoutes = moreRoutes;
    }
  });

  return flattenedSubRoutes;
}

export function generateNavigationMenuData(routesData) {
  const groupedRoutes = routesData
    .filter(route => {
      return generateNavPath(route);
    })
    .reduce((acc, route, i) => {
      if (!i || acc[acc.length - 1][0].navigation.group !== route.navigation.group) {
        return acc.concat([[route]]);
      }
      acc[acc.length - 1].push(route);
      return acc;
    }, [])
    .map(group => {
      return group.map(route => {
        return route.navigation;
      });
    });

  // console.log(groupedRoutes);

  return groupedRoutes;
}

//cleans up the path to be used in menu for navigation
function generateNavPath(route) {
  if (!route.navigation) return;
  const splitPath = route.path.split(':');
  let path = splitPath[0];
  if (path[path.length - 1] == '/') path = path.substring(0, path.length - 1);
  route.navigation.to = path;
  return route.navigation;
}
